import axios from "axios";
import qs from "qs";
// import { MessageBox, Message } from "element-ui";
// import { Msg } from "@/utils/tools"
import { Notify } from "vant";

export const API_URL = "http://192.168.10.123:8771/sys";
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  withCredentials: true, // 跨域请求时发送 cookies
  paramsSerializer: params => {
    // 查询字符串中的数组不使用方括号
    return qs.stringify(params, { indices: false });
  },
  timeout: 150000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // 如果是大屏或者养老云的请求，HTTP头携带Authorization和filterMode
    if (config.baseURL === process.env.VUE_APP_BASE_API) {
      config.headers["Authorization"] =
        "Bearer " + localStorage.getItem("accessToken");
      config.headers["filterMode"] = "prod";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
   */
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data;
    if (response.status === 200) {
      return res;
    }
  },
  error => {
    Notify({
      message: error.message,
      type: "danger",
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
